import React, { useState, useMemo } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/system';
import { useGetOrganizationsQuery } from '../../../features/organizations/organizationsApiSlice';
import { useParams } from 'react-router-dom';
import Header from '../global/Header';
import { Typography, Select, useTheme, Tab, Tabs, MenuItem } from '@mui/material';
import { tokens } from "../../../theme"
import ContributionMetrics from './components/ContributionMetrics';
import DomainAnalytics from './components/DomainAnalytics';
import CountSummaries from './components/CountSummaries';
import { useDiscreteMode } from '../global/DiscreteMode';



const MediaADC = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { organizationId } = useParams();
  const [dateRange, setDateRange] = useState('all');
  const [tabIndex, setTabIndex] = useState(0);
  const { data: organizations, isLoading, isError } = useGetOrganizationsQuery('organizations', {
    pollingInterval: 15000,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });





  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error occurred while fetching data</div>;






  const contributionMetricsOrganizations = Object.values(organizations.entities).filter((org) => {
    return org.cookie_pool_contribution_metrics && org.cookie_pool_contribution_metrics.length > 0;
  });
  console.log("Filtered Contributors: ", contributionMetricsOrganizations)





  return (
    <Box m="20px">
      <Tabs
        value={tabIndex}
        onChange={(event, newValue) => setTabIndex(newValue)}
        sx={{
          backgroundColor: '#3F4957', // Dark gray background
        }}
      >
        <Tab
          label="Count Summaries"
          style={{
            color: tabIndex === 0 ? '#8FBC8F' : 'white', // Bright green if selected, white if not
          }}
        />
        <Tab
          label="Contribution Metrics"
          style={{
            color: tabIndex === 1 ? '#8FBC8F' : 'white', // Bright green if selected, white if not
          }}
        />
        <Tab
          label="Domain Analytics"
          style={{
            color: tabIndex === 2 ? '#8FBC8F' : 'white', // Bright green if selected, white if not
          }}
        />
      </Tabs>

      {tabIndex === 0 && (
        <CountSummaries />
      )}

      {tabIndex === 1 && (
        <Box>
          <Header title="Contribution Metrics" />
          <ContributionMetrics data={contributionMetricsOrganizations} />
        </Box>
      )}
      {tabIndex === 2 && (
        <Box>
          <Header title="Domain Analytics" />
          <DomainAnalytics />
        </Box>
      )}
    </Box>
  );

};

export default MediaADC;
